import {SubAPI} from "./SubAPI";
import {Paginated} from "./Users";
import {Cents} from "nate-react-api-helpers";
import {PurchaseOrderItem} from "./Logistics";

export class MiscPricing extends SubAPI {
    list(props: {
        project: number
        offset: number;
        forSovLink?: boolean;
        previewChangeset?: number;
        awarded?: boolean;
    }) {
        return this.fetcher.get<Paginated<MiscPrice>>("/api/quote-misc-prices", props)
    }

    upsert(props: Partial<MiscPrice>) {
        return this.fetcher.post<MiscPrice>("/api/quote-misc-price", props)
    }

    reOrder(props: {
        project: number;
        alternative?: number;
        idOrder: number[];
    }) {
        return this.fetcher.post("/api/quote-misc-price/reorder", props)
    }

    createPoForItem(props: {
        id: number;
        supplier: number;
    }) {
        return this.fetcher.post<{id: number}>("/api/misc-price/create-po-for-item", props);
    }
}

export type MiscPrice = {
    id: number;
    project: number;

    name: string;
    publicNote: string;
    internalNote: string;
    
    markupPercent?: number;
    markupCents?: Cents;
    unitCostCents: Cents;
    extendedPrice: Cents;

    sovHeading: number | null;
    sovHeadingName: string | null;

    backup?: MiscPrice|null;

    purchaseOrderItems: PurchaseOrderItemWithStatus[];
}

export type PurchaseOrderItemWithStatus = PurchaseOrderItem & {
    poStatus: string;
    poNumber: string;
}